import { IconsProps } from '@/types/shared'
import React from 'react'

const UploadIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.07141 12.5V4.35L4.47141 6.95L3.07141 5.5L8.07141 0.5L13.0714 5.5L11.6714 6.95L9.07141 4.35V12.5H7.07141ZM2.07141 16.5C1.52141 16.5 1.05058 16.3042 0.658911 15.9125C0.267244 15.5208 0.0714111 15.05 0.0714111 14.5V11.5H2.07141V14.5H14.0714V11.5H16.0714V14.5C16.0714 15.05 15.8756 15.5208 15.4839 15.9125C15.0922 16.3042 14.6214 16.5 14.0714 16.5H2.07141Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default UploadIcons
